export default [
  {
    path: 'students',
    name: 'students',
    component: () => import('@/views/student/Students'),
    props: { role: 'student' },
    meta: {
      title: 'Danh sách học viên',
      auth: true,
      permission: 'view-student-list',
    },
  },
  {
    path: 'student/:id',
    name: 'studentInfor',
    component: () => import('@/views/student/Student'),
    props: { role: 'student' },
    meta: {
      title: 'Học viên',
      auth: true,
    },
  },
  {
    path: 'student-import',
    name: 'studentImport',
    component: () => import('@/views/student/StudentImporter.vue'),
    props: { role: 'student' },
    meta: {
      title: 'Student Importer',
      auth: true,
    },
  },
  {
    path: 'attendances',
    name: 'attendances',
    component: () => import('@/views/student/DiligenceTabs.vue'),
    meta: {
      title: 'Chuyên cần',
      auth: true,
      permission: 'view-attendance-item',
    },
  },
  {
    path: 'complimented',
    component: () => import('@/views/violation/Violations.vue'),
    name: 'Violation',
    meta: {
      title: 'Ghi chú cần theo dõi',
      auth: true,
      permission: 'view-violation-list',
    },
  },
]
